import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { toast } from "react-toastify";

import { formatDateTime } from "~/libs";

import {
  useApisAdminOperatorsNavigationItemsIndex,
  useApisAdminOperatorsCompaniesEdit,
  useApisAdminOperatorsNavigationItemsUpdate,
} from "~/hooks";

import { AdminOperatorLayout } from "~/components/layouts";

import { NavigationItemCompanyType } from "~/domains";

import { GridHeaderCells } from "~/ui";
import { GridRow, OpenedMenuInGrid } from "~/ui";

export const AdminOperatorsNavigationItemsIndex: FC = () => {
  const { companyId = "" } = useParams<{ companyId: string }>();

  const { data: companyData } = useApisAdminOperatorsCompaniesEdit({
    id: companyId,
  });

  const { data } = useApisAdminOperatorsNavigationItemsIndex({
    companyId,
  });

  const { mutate: updateNavigationItem } =
    useApisAdminOperatorsNavigationItemsUpdate();

  const handleUpdateNavigationItem = (
    item: NavigationItemCompanyType,
    hiddenAt: string | null,
  ) => {
    const displayText = item.hiddenAt ? "表示する" : "非表示にする";
    const isConfirm = confirm(displayText);
    if (!isConfirm) return;

    updateNavigationItem(
      {
        companyId: companyId,
        id: item.id,
        body: { hiddenAt: hiddenAt },
      },
      {
        onSuccess: (data) => {
          toast.success(data.message);
        },
      },
    );
  };

  const breadCrumbItems = [
    {
      label: "運営者画面",
      href: "/admin_operators",
    },
    {
      label: "会社一覧",
      href: "/admin_operators",
    },
    {
      label: companyData?.company.name || "",
      href: `/admin_operators/companies/${companyId}`,
    },
    {
      label: "サイドバー項目設定",
      href: `/admin_operators/companies/${companyId}/navigation_items`,
    },
  ];

  return (
    <AdminOperatorLayout breadCrumbItems={breadCrumbItems}>
      <div className="flex items-center justify-between">
        <h1 className="text-xl">
          <span className="font-bold">{companyData?.company?.name}</span>{" "}
          のサイドバー項目設定
        </h1>
      </div>
      <div className="mt-4 grid grid-cols-7">
        <GridHeaderCells
          texts={["id", "名前", "表示順", "権限", "非表示日時"]}
        />
        {data?.navigationItems.map((item) => (
          <GridRow
            key={item.id}
            lists={[
              item.id,
              item.name,
              item.position,
              item.role,
              item.hiddenAt,
            ]}
            openedMenu={
              <OpenedMenuInGrid
                cols={4}
                buttons={[
                  {
                    text: item.hiddenAt ? "表示する" : "非表示にする",
                    onClick: () =>
                      handleUpdateNavigationItem(
                        item,
                        item.hiddenAt
                          ? null
                          : formatDateTime(new Date(), "yyyy-MM-dd HH:mm:ss"),
                      ),
                  },
                ]}
              />
            }
          />
        ))}
      </div>
    </AdminOperatorLayout>
  );
};
